<template>
    <main class="c-app-content is-sidebar-tiny">
        <div class="row">
            <div class="col-12">
                <g-loading v-if="firstLoading" />
                <g-table v-else :filter="filterFormModel" :itemCount="itemCount" :items="items" :fields="fields" :isSelected="false" @load="load" @reset="reset" title="Dịch vụ công" titleIcon="fa fa-cube">
                    <template slot="filter">
                        <time-range-picker class="mr-2" :model="filterFormModel" label="Thời gian tạo" :defaultShortcut="10" @change="search" />
                    </template>
                    <template slot="actionBefore">
                        <b-tabs class="c-tabs-button mr-2" small pills v-model="filterFormModel.public" @input="search">
                            <b-tab :title="'Tất cả (' + (Number(params.countPublic) + Number(params.countPrivate)) + ')'"></b-tab>
                            <b-tab :title="'Bản nháp (' + this.params.countPrivate + ')'"></b-tab>
                            <b-tab :title="'Công khai (' + this.params.countPublic + ')'"></b-tab>
                        </b-tabs>
                    </template>
                    <template slot="action" v-if="permissions('public-service_create')">
                        <router-link to="/public-service/create" v-slot="{href, navigate}">
                            <a class="btn btn-success btn-sm" :href="href" @click="navigate">
                                <i class="fa fa-plus"></i>
                                Thêm mới
                            </a>
                        </router-link>
                    </template>
                    <template #cell(title)="{item}">
                        <div>
                            <span class="small text-gray-999">Tiêu đề: </span> 
                            <span v-if="item.title && item.title.length > 80"  v-readMore:80="item.title" ></span>
                            <span v-else>{{item.title}}</span>
                        </div>
                        
                    </template>
                    <template #cell(field)="{item}">
                        <div v-if="params.field[item.field]">
                            <!-- <span class="small text-gray-999">Lĩnh vực: </span> -->
                            <span v-if="params.field && params.field[item.field]" class="badge bg-gray ml-1" >
                                    {{params.field[item.field].name}}
                            </span>
                        </div>
                    </template>
                    <template #cell(status)="{item}">
                        <div>
                            <!-- <span class="small text-gray-999">Trạng thái: </span> -->
                            <span v-if="item.public == 0" class="badge bg-secondary ml-1" > Bản nháp </span>
                            <span v-else class="badge bg-success ml-1" >Công khai </span>
                        </div>
                    </template>
                    <template #cell(time)="{item}">
                        <div>
                            <span class="small text-gray-999">Tạo lúc: </span> {{item.created_time * 1000 |  moment('DD/MM/YYYY')}}
                        </div>
                        <div>
                            <span class="small text-gray-999">Cập nhật lúc: </span> {{item.updated_time * 1000 |  moment('DD/MM/YYYY')}}
                        </div>
                    </template>
                    <template #cell(action)="{item}">
                        <router-link v-if="permissions('public-service_update')"  :to="`/public-service/update/${item.id}`" v-slot="{href, navigate}">
                            <a class="btn btn-outline-gray btn-sm ml-1 mb-1" :href="href" @click="navigate">
                                <b-icon icon="pencil" aria-hidden="true"></b-icon>
                            </a>
                        </router-link>
                        <g-button v-if="permissions('public-service_del')" :loading="delLoading" size="sm" variant="outline-danger" class="ml-1 mb-1" icon="trash-fill" @click='del(item.id)' />
                    </template>
                </g-table>
            </div>
        </div>
    </main>
</template>

<script>
    import list from "@/mixins/List";
    import crud from '@/mixins/CRUD';
    import role from '@/mixins/Role';
    export default {
        mixins: [list, crud, role],
        data: function () {
            return {
                service: '/public-service',
                fields: [
                    {key: 'title', label: "Tiêu đề"},
                    {key: 'field', label: "Lĩnh vực"},
                    {key: 'status', label: "Trạng thái"},
                    {key: 'time', label: "Thông tin"},
                    {key: 'action', label: "Hành động", class: 'text-right'},
                ],
                defaultFilterFormModel: {
                    keyword: '',
                    parameters: [
                    ],
                    public: 0,
                    field: null,
                    lang: null,
                    pagex: null,
                    highlight: null,
                    comment_status: null,
                    created_by: null,
                },
                defaultFormModel: {
                },
                statusOptions: [],
                categogyOptions: [],
                langOptions: [
                    {value: null, text: "Tất cả Ngôn ngữ"},
                    {value: "vi", text: "Tiếng Việt"},
                    {value: "en", text: "Tiếng Anh"},
                ],
            };
        },
        methods: {
            beforeLoad() {
                this.statusOptions = [
                    {value: null, text: 'Tất cả (' + (Number(this.params.countPublic) + Number(this.params.countPrivate)) + ')'},
                    {value: 'private', text: 'Bản nháp (' + this.params.countPrivate + ')'},
                    {value: 'public', text: 'Công khai (' + this.params.countPublic + ')'}
                ];
            },
        },
        mounted: function () {
            this.$bus.$on('reloadPost', this.load);
        },
        beforeDestroy: function () {
            this.$bus.$off('reloadPost');
        },
    }
</script>